import Vue from 'vue'
import {HTTP} from '@/http'
// initial state
const state = {
  user: {
    userName: '',
    userEmail: '',
    userId: '',
    userDesc: '',
    loggedInStatus: false,
    authToken: '',
    access: []
  },
  airportDetails: {}
}
// mutations
const mutations = {
  addWebToken: function (state, webToken) {
    state.user.authToken = webToken
  },
  removeWebToken: function (state) {
    state.user.authToken = ''
    state.user.loggedInStatus = false
  },
  setUserFromLS: function (state, user) {
    state.user = user
    HTTP.defaults.headers.common['Authorization'] = 'Bearer ' + user.authToken
  },
  setUserDetails: function (state, uDetails) {
    state.user.userId = uDetails.ID_USER
    state.user.userName = uDetails.NAME
    state.user.userDesc = uDetails.NAME_E
    state.user.userAvatar = '../static/img/avatar.png'
    state.user.access = uDetails.access
    // this.$router.push('/')
    state.user.loggedInStatus = true

    Vue.ls.set('user', state.user, 24 * 60 * 60 * 1000) // Данные пользователя хранятся 24 ч
  },
  setApDetail: function (state, data) {
    state.airportDetails = data
  },
  setCurrency(_, data) {
    localStorage.setItem('currency', data)
  }
}
// actions
const actions = {
  async login (context, userInput) {
    await HTTP.post('/api/login', {
      login: userInput.login,
      password: userInput.password,
      application: 'rsr'
    })
      .then(response => {
        context.commit('setCurrency', response.data.currency)
        context.commit('addWebToken', response.data.access_token)
        HTTP.defaults.headers.common['Authorization'] = 'Bearer ' + response.data.access_token
        this.dispatch('userDetails')
      })
      .catch(e => {
        this.errorMessage = e
        this.dispatch('errorProcess', e)
      })
  },
  async userDetails (context) {
    await HTTP.get('/api/get-details')
      .then(response => {
        if (response.status === 200) {
          context.commit('setUserDetails', response.data.success)
          this.dispatch('getApDetail')
          this.dispatch('globalDataUpdate')
        }
      })
      .catch(e => {
        this.errorMessage = e
        this.dispatch('errorProcess', e)
      })
  },
  async getApDetail (context) {
    await HTTP.get('/api/get-airport')
      .then(response => {
        if (response.status === 200) {
          context.commit('setApDetail', response.data)
          Vue.ls.set('airport', response.data, 24 * 60 * 60 * 1000)
        }
      })
      .catch(e => {
        this.errorMessage = e
        this.dispatch('errorProcess', e)
      })
  },
  checkLocalUser (context) {
    if (!context.getters.getUser['loggedInStatus']) {
      let lsUser = Vue.ls.get('user')
      if (lsUser != null) {
        context.commit('setUserFromLS', lsUser)
      }
      let airportDetail = Vue.ls.get('airport')
      if (airportDetail != null) {
        context.commit('setApDetail', airportDetail)
      }
    }
  },
  logout: function (context) {
    context.commit('removeWebToken')
    Vue.ls.remove('user')
    Vue.ls.remove('airport')
  }
}
// getters
const getters = {
  getUser (state) {
    return state.user
  },
  getAirportDetails (state) {
    return state.airportDetails
  },
  getAirportPosition (state) {
    let position = [parseFloat(state.airportDetails.long), parseFloat(state.airportDetails.lat)]
    return position || [90, 40]
  },
  getUserAccess (state) {
    return state.user.access || []
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
